<div class="da-card da-{{ size }}"
     [class.da-clickable]="clickable || selectable"
     [class.da-selected]="selected"
     (click)="onClick()">

  <!-- Square image cell: artwork is shown WHOLE (object-fit: contain), never cropped -->
  <div class="da-thumb">
    <img [src]="imageUrl || fallback" (error)="onImgError($event)" [alt]="name || ''" loading="lazy" />
    @if (status) {
      <span class="da-badge da-tone-{{ statusTone }}">{{ status }}</span>
    }
    @if (selectable) {
      <span class="da-check" [class.on]="selected" aria-hidden="true"><i class="fa fa-check"></i></span>
    }
  </div>

  <!-- Meta -->
  <div class="da-body">
    @if (name) { <div class="da-name" [title]="name">{{ name }}</div> }
    @if (artist) { <div class="da-sub"><i class="fa fa-user-o"></i> <span>{{ artist }}</span></div> }
    @if (subtitle) { <div class="da-sub"><span>{{ subtitle }}</span></div> }
    @if (price !== null && price !== undefined) {
      <div class="da-price">
        @if (priceLabel) { <span class="da-price-label">{{ priceLabel }}</span> }
        <span>{{ price | currency: currency : 'symbol' : '1.0-2' }}</span>
      </div>
    }
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
